import { logOutUser } from '../services/AccountApi/louOutApi';
import { toastNotify } from './toastNotify';
import { removeCookie } from './cookies';

export const handleLogOutUser = async () => {
  try {
    const resp = await logOutUser();
    if (!resp.isError) {
      toastNotify('success', resp?.message);
      return true;
    } else {
      toastNotify('error', resp?.message);
      return false;
    }
  } catch (error) {
    const { response } = error;
    toastNotify('error', response?.data?.message);
    return true;
  } finally {
    localStorage.removeItem('redirectIntendedPage');
    localStorage.clear();
    removeCookie();
    if(process.env.REACT_APP_WEBFLOW_LOGIN=== 'production'){
    document.cookie = `user_login=''; path=/; domain=.realbricks.com`;
    }
  }
};
